export const alertConstants = {
  SUCCESS: 'success',
  ERROR: 'danger',
  WARNING: 'warning'
};

export const userConstants = {
FETCH_USER: 'FETCH_USER',
SET_USER: 'SET_USER'
};

export const settingsConstants = {
FETCH_SETTINGS: 'FETCH_SETTINGS',
SET_SETTINGS: 'SET_SETTINGS'
};

export const permissionsConstants = {
FETCH_PERMISSIONS: 'FETCH_PERMISSIONS',
SET_PERMISSIONS: 'SET_PERMISSIONS'
}

export const versionsConstants = {
  SET_SELECTED_VERSIONS: "SET_SELECTED_VERSIONS",
  FREEZE_TRAINING_DATA: "FREEZE_TRAINING_DATA"
};

export const CHANNEL_MAP ={
  OMNI_VOICE_00001: 'Voice',
  OMNI_WEBCHAT_00001: 'VIVR'
}